import { ref } from 'vue'
import type { RouteLocationNormalized } from 'vue-router'

export type ChatScopeType =
  | 'account'
  | 'agent'
  | 'workspace'
  | 'agent_dialer'
  | 'human_dialer'
  | 'sales_play'

export interface ChatScope {
  scopeType: ChatScopeType
  scopeSubjectId: string
  pageContext: Record<string, string> | null
  currentRoute: RouteLocationNormalized | null
}

const DEFAULT_SCOPE: ChatScope = {
  scopeType: 'workspace',
  scopeSubjectId: '',
  pageContext: null,
  currentRoute: null,
}

const scope = ref<ChatScope>({ ...DEFAULT_SCOPE })

export function useChatScope() {
  function setScope(next: Partial<ChatScope>) {
    scope.value = {
      ...scope.value,
      scopeType: (next.scopeType ?? scope.value.scopeType) as ChatScopeType,
      scopeSubjectId: String(next.scopeSubjectId ?? scope.value.scopeSubjectId ?? ''),
      pageContext: next.pageContext === undefined ? scope.value.pageContext : next.pageContext,
    }
  }
  function setCurrentRoute(route: RouteLocationNormalized) {
    scope.value = { ...scope.value, currentRoute: route }
  }
  function clearScope() {
    scope.value = { ...DEFAULT_SCOPE, currentRoute: scope.value.currentRoute }
  }
  return { scope, setScope, setCurrentRoute, clearScope }
}
